export default {
  nav_spreadsheet: 'CSSBuy Spreadsheet',
  nav_home: 'Início',
  nav_shopping_guide: 'Guia de Compras',
  nav_reviews: 'Reviews',
  nav_shipping: 'Envio',
  nav_coupons: 'Cupons',
  nav_guides: 'Guias',
  nav_safety: 'Segurança',
  nav_warehouse: 'Armazém',
  nav_blog: 'Blog',
  nav_about: 'Sobre',
  nav_contact: 'Contato',
  nav_faq: 'FAQ',
  hero_title: 'CSSBuy Spreadsheet 2026: Encontre Produtos, Links e Guias',
  hero_subtitle: 'Explore um recurso independente de CSSBuy Spreadsheet com pesquisa de produtos, guias de categorias, explicações de QC, informações de envio e dicas práticas de compra.',
  hero_cta_primary: 'Explorar CSSBuy Spreadsheet',
  hero_cta_secondary: 'Ver Guias',
  trust_badge: 'Recurso independente · Conteúdo atualizado · Guias práticos · PT / EN / DE',
  what_is_title: 'O que é um CSSBuy Spreadsheet?',
  what_is_p1: 'Um CSSBuy Spreadsheet é uma forma organizada de reunir produtos, links, categorias e informações úteis para facilitar a pesquisa. Ele ajuda a encontrar informações mais rapidamente, mas cada item deve ser verificado antes da compra.',
  what_is_p2: 'Um spreadsheet não garante qualidade, preço, estoque, disponibilidade ou entrega. Confirme sempre as informações atuais antes de finalizar qualquer pedido.',
  what_is_cta: 'Ver CSSBuy Spreadsheet',
  how_it_works_title: 'Como usar o CSSBuy Spreadsheet',
  step_1: 'Escolha uma categoria',
  step_2: 'Encontre um produto ou link',
  step_3: 'Confira preço e informações',
  step_4: 'Verifique QC, tamanho e detalhes',
  step_5: 'Compare alternativas',
  step_6: 'Confirme as condições atuais',
  step_7: 'Continue no site principal',
  how_cta: 'Começar Agora',
  categories_title: 'Explore Categorias',
  categories_subtitle: 'Navegue pelas categorias de produtos e encontre o que precisa',
  guides_title: 'Guias CSSBuy Mais Procurados',
  guides_subtitle: 'Guias detalhados para ajudar a navegar no CSSBuy com segurança',
  comparison_title: 'CSSBuy Spreadsheet vs Pesquisa Tradicional',
  comparison_feature: 'Recurso',
  comparison_spreadsheet: 'CSSBuy Spreadsheet',
  comparison_traditional: 'Pesquisa Tradicional',
  comparison_org: 'Organização por categoria',
  comparison_links: 'Links reunidos',
  comparison_guides: 'Guias específicos',
  comparison_compare: 'Comparação',
  comparison_intent: 'Pesquisa por intenção',
  comparison_yes: 'Sim',
  comparison_no: 'Não',
  comparison_limited: 'Limitada',
  comparison_easy: 'Fácil',
  comparison_manual: 'Manual',
  safety_title: 'Pesquise com Mais Segurança',
  safety_tip_1: 'Verifique o domínio e o link antes de acessar',
  safety_tip_2: 'Confirme informações do produto',
  safety_tip_3: 'Confira tamanho e opções',
  safety_tip_4: 'Leia informações de QC',
  safety_tip_5: 'Verifique custos de envio',
  safety_tip_6: 'Confirme cupons atuais',
  safety_tip_7: 'Nunca compartilhe senhas',
  safety_tip_8: 'Nunca envie dados financeiros para sites desconhecidos',
  safety_cta: 'Ler Guia de Segurança',
  articles_title: 'Últimos Guias CSSBuy',
  articles_subtitle: 'Artigos e guias detalhados para compras seguras',
  read_guide: 'Ler Guia',
  reading_time: 'min leitura',
  updated: 'Atualizado',
  faq_title: 'Perguntas Frequentes',
  faq_subtitle: 'Perguntas comuns sobre CSSBuy Spreadsheet',
  final_cta_title: 'Pronto para começar?',
  final_cta_subtitle: 'Explore o CSSBuy Spreadsheet e continue sua pesquisa no nosso site principal.',
  final_cta_button: 'Explorar CSSBuy Spreadsheet',
  main_cta_button: 'Comprar Agora',
  footer_resources: 'Recursos',
  footer_company: 'Empresa',
  footer_disclaimer: 'Recurso informativo independente. Não é o site oficial da CSSBuy. Informações externas podem mudar.',
  lang_pt: 'PT',
  lang_en: 'EN',
  lang_de: 'DE',
  editorial_policy: 'Política Editorial',
  disclaimer: 'Aviso Legal',
  privacy: 'Política de Privacidade',
  about_us: 'Sobre Nós',
  article_author: 'Equipe Editorial',
  article_related: 'Artigos Relacionados',
  article_toc: 'Índice',
  article_quick_answer: 'Resposta Rápida',
  article_pros: 'Vantagens',
  article_cons: 'Desvantagens',
  article_checklist: 'Lista de Verificação',
  breadcrumb_home: 'Início',
  breadcrumb_guides: 'Guias',
  category_select: 'Selecione uma Categoria',
  category_dropdown_label: 'Navegar Categorias',
  home_seo_title: 'CSSBuy Spreadsheet 2026: Links, Guias e Produtos',
  home_seo_description: 'Explore o CSSBuy Spreadsheet 2026 com links, categorias, guias, QC, envio, cupons e informações práticas para pesquisar produtos com mais segurança.',
  home_seo_keywords: 'CSSBuy Spreadsheet, CSSBuy links, CSSBuy guia, CSSBuy QC, CSSBuy envio, CSSBuy cupom',
  back_to_home: 'Voltar ao Início',
  learn_more: 'Saiba Mais',
  view_all: 'Ver Todos',
  search: 'Buscar',
  minutes_read: 'min leitura',
  share: 'Compartilhar',
  copy_link: 'Copiar Link',
  copied: 'Copiado!',
};